<template>
  <v-menu left offset-y offset-x rounded="lg" min-width="150">
    <template #activator="{ on, attrs }">
      <v-icon class="p-1 m-1 bg-white rounded-full" v-bind="attrs" v-on="on"
        >mdi-dots-vertical</v-icon
      >
    </template>
    <v-list>
      <v-list-item
        v-for="(action, index) in actions"
        :key="index"
        :class="{ 'opacity-50 pointer-events-none': action.disabled }"
        @click="!action.disabled && action.handler(item)"
      >
        <v-list-item-title>
          <v-icon
            v-if="!!action?.icon"
            size="20"
            class="mr-2"
            :color="action.icon?.color || 'primary'"
          >
            {{ action.icon?.name }}
          </v-icon>
          {{ action.title }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { TableActionsMenu } from '@/types/table';

export default defineComponent({
  name: 'CfsTableActionsMenu',
  props: {
    actions: {
      type: Array as PropType<TableActionsMenu<unknown>[]>,
      required: true,
    },
    item: {
      type: [Object, Boolean] as PropType<unknown>,
      default: null,
    },
  },
});
</script>
